import { useFormFieldsValidators, useTranslations } from "@jugl-web/utils";
import React from "react";
import { TextInput } from "@jugl-web/ui-kit";
import { Controller, useFormContext } from "react-hook-form";
import { AppearanceSettingsTabShell } from "../AppearanceSettingsTabShell";
import { TabHeader } from "../../../../components/TabHeader";
import { Separator } from "../../../../components/Separator";
import { LiveChatAppSettingsFormValues } from "../../types";

export const CustomButtonTabContent: React.FC = () => {
  const { t } = useTranslations();

  return (
    <AppearanceSettingsTabShell tabId="customButton">
      <TabHeader
        title={t({
          id: "client-support-page.custom-button",
          defaultMessage: "Custom Button",
        })}
        subtitle={t({
          id: "client-support-page.custom-button-description",
          defaultMessage:
            "Add a button that links customers to your key pages or actions, like booking, ordering, or visiting your website",
        })}
      />
      <Separator className="my-8" />
      <CustomButtonTabContentInner />
    </AppearanceSettingsTabShell>
  );
};

const CustomButtonTabContentInner: React.FC = () => {
  const { t } = useTranslations();

  const { urlValidator } = useFormFieldsValidators();
  const { control } = useFormContext<LiveChatAppSettingsFormValues>();

  return (
    <div className="flex flex-col gap-6">
      <Controller
        control={control}
        name="customButton.title"
        render={({ field: { onChange, ...field } }) => (
          <TextInput
            label={t({
              id: "client-support-page.button-title",
              defaultMessage: "Button Title",
            })}
            labelPosition="border-overlap"
            placeholder={t({
              id: "common.enter",
              defaultMessage: "Enter",
            })}
            classNames={{ wrapperClassName: "w-full" }}
            onChange={(e) => onChange(e.target.value.trimStart())}
            {...field}
          />
        )}
      />
      <Controller
        control={control}
        name="customButton.url"
        rules={{ ...urlValidator(true) }}
        render={({ field: { onChange, ...field }, fieldState }) => (
          <TextInput
            label={t({
              id: "common.link",
              defaultMessage: "Link",
            })}
            labelPosition="border-overlap"
            placeholder="mybusiness.com"
            classNames={{ wrapperClassName: "w-full" }}
            isInvalid={fieldState.invalid}
            errorMessage={fieldState.error?.message}
            onChange={(e) => onChange(e.target.value.trimStart())}
            {...field}
          />
        )}
      />
    </div>
  );
};
